export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20fashion%20collage%20with%20scattered%20clothing%20accessories%20elegantly%20arranged%20on%20a%20light%20sand%20colored%20surface%2C%20soft%20natural%20window%20light%20casting%20delicate%20shadows%2C%20linen%20fabric%20textures%2C%20leather%20sneakers%2C%20gold%20toned%20jewelry%20pieces%2C%20ceramic%20vase%20with%20dried%20flowers%2C%20refined%20editorial%20composition%20with%20negative%20space%2C%20calm%20and%20airy%20atmosphere%20with%20touches%20of%20olive%20and%20rust%20tones&width=1800&height=900&seq=hero-bg-2026-n1&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 text-center lg:text-left w-full">
            <span className="inline-block px-4 py-1.5 bg-primary-500/20 text-primary-300 rounded-full text-xs font-medium mb-6 tracking-wide">
              UPDATED FOR 2026
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
              The Ultimate{' '}
              <span className="text-primary-400">Kakobuy Spreadsheet</span>
              <br />
              For Smart Product Discovery
            </h1>
            <p className="mt-5 text-base md:text-lg text-background-300 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              Find thousands of trending products, organized categories, detailed guides, and verified shopping resources in one powerful spreadsheet. Your gateway to smarter shopping decisions.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 mt-8 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-md text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                Kakobuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-background-300 text-background-100 rounded-md text-base font-semibold hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                Buy It Now
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-6 mt-8 justify-center lg:justify-start">
              {['Updated Product Database', 'Organized Categories', 'Beginner Friendly Guides', 'Shopping Safety Resources'].map((item) => (
                <div key={item} className="flex items-center gap-2 text-sm text-background-300">
                  <span className="w-5 h-5 flex items-center justify-center text-primary-400">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  {item}
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 hidden lg:flex justify-center">
            <div className="relative w-[420px] h-[420px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20curated%20fashion%20products%20arranged%20in%20an%20artistic%20grid%20pattern%2C%20premium%20sneakers%2C%20folded%20knit%20sweaters%2C%20leather%20accessories%2C%20sunglasses%2C%20minimalist%20watch%2C%20all%20in%20earthy%20neutral%20tones%20of%20sand%20terracotta%20olive%20and%20cream%2C%20soft%20diffused%20overhead%20lighting%2C%20clean%20elegant%20composition%20with%20intentional%20negative%20space%2C%20luxury%20editorial%20catalog%20aesthetic&width=840&height=840&seq=hero-product-2026-n2&orientation=squarish"
                alt="Kakobuy Spreadsheet product collection preview"
                title="Kakobuy Spreadsheet product finds collection"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-background-300/20"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#what-is" className="w-10 h-10 flex items-center justify-center text-background-300 hover:text-background-100 transition-colors cursor-pointer">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}